<template>
  <span>
    <span @click="showModal">
      <slot></slot>
    </span>
    <b-modal v-model="modalView" size="lg" centered no-fade>
      <div slot="modal-header">{{$t('TEAM.APPLICATION_ADD.TITLE')}}</div>
      <div class="p-4 text-center" v-if="modalLoading">
        <img src="/img/loading.gif" />
        <h5 style="margin: 0; padding: 0;">{{$t('TEAM.APPLICATION_ADD.PROCESSING')}}</h5>
      </div>
      <div class="pl-4 pr-4" v-if="modalLoading === false">
        <form enctype="multipart/form-data">
          <div class="form-group row">
            <label class="col-form-label">{{ $t('TEAM.APPLICATION_ADD.INPUT_NAME') }}</label>
            <b-input
             v-on:keyup.enter="modalSubmit"
              v-model="addName"
              type="text"
              name="name"
              required
              autofocus
            ></b-input>
          </div>

        </form>
      </div>
      <div slot="modal-footer" class="w-100">
        <div v-if="modalLoading === false">
          <b-btn @click="hideModal">{{ $t('CLOSE')}}</b-btn>
          <b-button
            variant="primary"
            class="btn-fill"
            @click="modalSubmit"
          >{{ $t('TEAM.APPLICATION_ADD.SUBMIT')}}</b-button>
        </div>
      </div>
    </b-modal>
  </span>
</template>
<script>
export default {
  data() {
    return {
      modalView: false,
      modalLoading: false,
      addName: "",
      user: this.$store.getters["auth/user"]
    };
  },
  methods: {
    showModal() {
      this.modalView = true;
    },
    hideModal() {
      this.modalView = false;
      this.addName = "";
      this.modalLoading = false;
    },
    modalSubmit: function() {
      let self = this;
      this.modalLoading = true;
      this.$http
        .post(process.env.VUE_APP_BACKEND + `/team/application/add`, {
          name: this.addName
        })
        .then(function() {
          self.hideModal();
          self.$emit("addedEvent");
          self.$noty.info(self.$t("TEAM.APPLICATION_ADD.SUCCESS.ADDED_USER"));
        })
        .catch(function(error) {
          self.modalLoading = false;
          self.$noty.error(self.$t(error.response.data));
        });
    }
  }
};
</script>
<style>
</style>